import React from 'react'
import ImgResponsive from './ImgResponsive'

const StaticImage = ({ src, ...props }) => <ImgResponsive {...props} src={`/static${src}`} />

export default StaticImage
